import { environment } from './../../../../environments/environment';
import {Injectable} from '@angular/core';
import {BackendService} from '../../core/services/backend.service';
import * as FileSaver from 'file-saver';
import {concat, from, of} from 'rxjs';
import {catchError, last, map, skipWhile, takeWhile} from 'rxjs/operators';
import * as _ from 'lodash';
import {FeatureActionTypes, IFileUploadItem} from './store';
import {HttpEvent, HttpEventType, HttpHeaders, HttpRequest} from '@angular/common/http';



@Injectable()
export class Service extends BackendService {


    doLoad(fileItem){
        return from(this.download(fileItem))
    }

    doAdd(fileItems: Array<IFileUploadItem>) {
        return this.uploadMultipleS3SignedUrls(fileItems)
    }

    async download(fileItem) {
        let resourceUrl: string = undefined;
        if(fileItem.id) {
            let token = await this.getDownloadToken(fileItem);
            resourceUrl = environment.apiServerUrl + 'files/download?token=' + token.token;
            window.open(resourceUrl);
        }
        else {
            resourceUrl = environment.apiServerUrl + 'files/downloadMultiple?fileObj=' + JSON.stringify(fileItem);
            window.open(resourceUrl);
        }
        return fileItem
    }

    async getDownloadToken(fileItem){
        return super.doLoad('files/download/token?id=' + fileItem.id)
            .toPromise()
    }

    upload(blottedFileItem){
        const formData: FormData = new FormData();
        formData.append('file', blottedFileItem.file, blottedFileItem.file.name);

        const req = new HttpRequest('POST', this.apiUrl + 'files?path=' + blottedFileItem.path, formData, _.merge(this.httpOptions,
            { reportProgress: true,
                observe: 'events',
                responseType: 'blob' as 'json'
            }));

        return this.http.request(req).pipe(
            map(event => this.getEventMessage(event, blottedFileItem.file)),
            last(response => _.merge({ parent: blottedFileItem.parent, data: response })), // return last (completed) message to caller
            catchError(this.handleError)
        );
    }

    uploadV2(blottedFileItem){
        const formData: FormData = new FormData();
        formData.append('file', blottedFileItem.file, blottedFileItem.file.name);

        const req = new HttpRequest('POST', this.apiUrl + 'v2/folders/' + blottedFileItem.parent.id + '/files?name=' + blottedFileItem.file.name, formData, _.merge(this.httpOptions,
            { reportProgress: true,
                observe: 'events'
            }));

        return this.http.request(req).pipe(
            map(event => this.getEventMessage(event, blottedFileItem)),
            last(response => _.merge({ parent: blottedFileItem.parent, data: response })), // return last (completed) message to caller
            catchError(this.handleError)
        );
    }

    uploadV3(blottedFileItem){
        const formData: FormData = new FormData();
        formData.append('file', blottedFileItem.file, blottedFileItem.file.name);

        const req = new HttpRequest('POST', this.apiUrl + 'v2/files/' + blottedFileItem.id + '/upload', formData, _.merge(this.httpOptions,
            { reportProgress: true,
                observe: 'events'
            }));

        this.http.request(req).pipe(
            map(event => this.getEventMessage(event, blottedFileItem)),
            last(response => _.merge({ parent: blottedFileItem.parent, data: response })), // return last (completed) message to caller
            catchError(this.handleError)
        ).toPromise()
            .then();

        return of(blottedFileItem)
    }

    stage(fileItem: IFileUploadItem) {
        let httpBody = {
            name: fileItem.file.name,
            size: fileItem.file.size,
            contentType: fileItem.file.type
        };
        return this.http.post(this.apiUrl + 'v2/folders/' + fileItem.parent.id + '/files/stage?name=' + fileItem.file.name, httpBody, this.httpOptions)
    }

    uploadMultiple(fileItems: Array<IFileUploadItem>){
        let formData: FormData = new FormData();
        _.forEach(fileItems, (fileItem: IFileUploadItem) => {
            formData.append('file', fileItem.file, fileItem.file.name);
        });
        return this.uploadFileRequest(formData, fileItems[0].parent.id)
            .pipe(
                map(response => _.merge({ parent: fileItems[0].parent, data: response })),
                catchError(super.handleError)
            )
    }

    uploadMultipleS3SignedUrls(fileItems: Array<IFileUploadItem>){
        return concat(this.http.post(this.apiUrl + 'folders/upload/' + fileItems[0].parent.id + '/files',
            {files: _.map(fileItems, (f) => { return {
                    name: f.file.name,
                    type: f.file.type,
                    size: f.file.size
                } } ) },
            this.httpOptions
        ).pipe(
            map(response => [response, fileItems]),
            catchError(super.handleError)
        ))


    }

    uploadS3(data, fileItems){
        return _.map(data, (item: any) => {

            let fileItem = _.find(fileItems, (f) => f.file.name === item.name);
            fileItem.signedUrl = item.signedUrl;

            let formData: FormData = new FormData();
            formData.append('files[0]', fileItem.file, fileItem.file.name);

            return this.http.put(fileItem.signedUrl, formData, _.merge(this.awsHttpOptions(fileItem.file.type, fileItem.file.size), { responseType: 'blob' as 'json' }))
                .pipe(
                    map(response => { return { parent: fileItem.parent } }),
                    catchError(super.handleError)
                )

        })
    }

    uploadFileRequest(formData: FormData, parentId: string) {
        return this.http.post(this.apiUrl + 'folders/' + parentId + '/files', formData, _.merge(this.httpOptions, { responseType: 'blob' as 'json' }))
    }

    awsHttpOptions(contentType, size) {
        console.log(size)
        return {
            headers: new HttpHeaders({
                'Content-Type': contentType,
                'Authorization': 'Bearer ' + this.token
            })
        };
    }


    private getEventMessage(event: HttpEvent<any>, fileItem: IFileUploadItem | any) {
        switch (event.type) {
            case HttpEventType.Sent:
                return `Uploading file "${fileItem.file.name}" of size ${fileItem.file.size}.`;

            case HttpEventType.UploadProgress:
                // Compute and show the % done:
                const percentDone = Math.round(100 * event.loaded / event.total);

                this.store.dispatch({
                    type: FeatureActionTypes.UploadingInProgress,
                    payload: {fileId: fileItem.id, percent: percentDone}
                });

                return `File "${fileItem.file.name}" is ${percentDone}% uploaded.`;

            case HttpEventType.Response:
                //return `File "${fileItem.file.name}" was completely uploaded!`;
                this.store.dispatch({
                    type: FeatureActionTypes.UploadingInProgressComplete,
                    payload: {fileId: fileItem.id, percent: 100}
                });


                return { parent: fileItem.parent };

            default:
                return `File "${fileItem.file.name}" surprising upload event: ${event.type}.`;
        }
    }

    private getDownloadEventMessage(event: HttpEvent<any>, fileItem: IFileUploadItem | any) {
        switch (event.type) {
            case HttpEventType.Sent:
                return { completed: false, parent: fileItem.parent, event: event };

            case HttpEventType.DownloadProgress:
                // Compute and show the % done:
                const percentDone = Math.round(100 * event.loaded / fileItem.size );

                this.store.dispatch({
                    type: FeatureActionTypes.DownloadingInProgress,
                    payload: {fileId: fileItem.id, percent: percentDone}
                });
                console.log(`File "${fileItem.name}" is ${percentDone}% downloaded.`)

                return { completed: false, parent: fileItem.parent, event: event };

            case HttpEventType.Response:
                //return `File "${fileItem.file.name}" was completely uploaded!`;
                this.store.dispatch({
                    type: FeatureActionTypes.DownloadingInProgressComplete,
                    payload: {fileId: fileItem.id, percent: 100}
                });

                return { completed: true, parent: fileItem.parent, blob: event.body, event: event };

            default:
                console.log(`File "${fileItem.name}" surprising upload event: ${event.type}.`)
                return { completed: false, parent: fileItem.parent, event: event };
        }
    }
}
